interface ErrorPayload {
  data?: {
    message?: string;
  };
}

const isErrorPayload = (payload: unknown): payload is ErrorPayload =>
  typeof payload === 'object' &&
  payload !== null &&
  'data' in payload &&
  typeof (payload as { data?: unknown }).data === 'object' &&
  (payload as { data?: { message?: unknown } }).data?.message !== undefined &&
  typeof (payload as { data: { message?: unknown } }).data.message === 'string';

const extractResponseMessage = (payload: unknown): string | undefined => {
  if (isErrorPayload(payload)) {
    return payload.data?.message;
  }
  return undefined;
};

export default extractResponseMessage;
